import React from 'react';
import PropTypes from 'prop-types';

const ModalBody = ({
  children,
  isHorizontal = false,
  className = '',
  style = {},
  gap = '16px',
}) => {
  const baseStyles = {
    display: 'flex',
    flexDirection: isHorizontal ? 'row' : 'column',
    flex: 1,
    gap: gap,
    overflow: 'hidden',
    ...style,
  };

  return (
    <div className={`modal-body ${className}`} style={baseStyles}>
      {children}
    </div>
  );
};

ModalBody.propTypes = {
  children: PropTypes.node.isRequired,
  isHorizontal: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  gap: PropTypes.string,
};

export default ModalBody;
